"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transact = transact;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _Dispatch = require("../dispatch/Dispatch");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isArray = _interopRequireDefault(require("transmute/isArray"));

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _isThenable = _interopRequireDefault(require("q/js/lib/isThenable"));

function enforceValidOptions(options) {
  var accept = options.accept,
      commit = options.commit,
      operation = options.operation,
      rollback = options.rollback;
  (0, _invariant.default)((0, _isFunction.default)(operation), 'expected `options.operation` to be a function but got `%s`', operation);
  (0, _invariant.default)(!accept || (0, _isArray.default)(accept) || (0, _isFunction.default)(accept), 'expected `options.accept` to be an optional array or function but got `%s`', accept);
  (0, _invariant.default)((0, _isArray.default)(commit), 'expected `options.commit` to be an array but got `%s`', commit);
  (0, _invariant.default)((0, _isArray.default)(rollback), 'expected `options.rollback` to be an array but got `%s`', rollback);
  return options;
}
/**
 * `transact` is a utility for optimistic updates with GeneralStore
 *
 * Example:
 *
 *  transact({
 *    opertion: API.save,
 *    commit: [COMMIT_ACTION_TYPE, optimisticData],
 *    accept: [ACCEPT_ACTION_TYPE, acceptData],
 *    rollback: [ROLLBACK_ACTION_TYPE, rollbackData],
 *  });
 *
 * The `commit` tuple is dispatched immediately. Then `operation` is
 * called (it must return a Promise).
 *
 * If the promise is resolved and an `accept` tuple is provided, then the tuple
 * is dispatched. Otherwise, nothing happens and every thing is fine.
 *
 * If the promise is rejected the `rollback` tuple is dispatched/
 *
 * @param  {Object}
 * @return {Promise}
 */


function transact(options) {
  var _enforceValidOptions = enforceValidOptions(options),
      accept = _enforceValidOptions.accept,
      commit = _enforceValidOptions.commit,
      operation = _enforceValidOptions.operation,
      rollback = _enforceValidOptions.rollback;

  _Dispatch.dispatchImmediate.apply(void 0, (0, _toConsumableArray2.default)(commit));

  var promise = operation();
  (0, _invariant.default)((0, _isThenable.default)(promise), 'expected operation to return a promise but got `%s`', promise);
  promise.then(function (result) {
    if ((0, _isArray.default)(accept)) {
      return _Dispatch.dispatchImmediate.apply(void 0, (0, _toConsumableArray2.default)(accept));
    }

    if ((0, _isFunction.default)(accept)) {
      return accept(result);
    }

    return _emptyFunction.default;
  }).catch(_partial.default.apply(void 0, [_Dispatch.dispatchImmediate].concat((0, _toConsumableArray2.default)(rollback)))).done();
  return promise;
}